import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useDocuments } from 'contexts/documents'
import { Header, Heading } from './s'
import { CloseButton } from 'components/button'
import Badge from 'components/badge'
import Message from 'components/message'
import Documents from 'pages/documents/lists/documents-slim'

const SigningPanelContent = ({ dismiss }) => {
    const { formatMessage } = useIntl()

    const { total } = useDocuments()

    return (
        <>
            <Header>
                <Heading>
                    <FormattedMessage
                        id="documents_heading_to_sign"
                        defaultMessage="Documents to sign" />
                </Heading>
                <Badge number={total} />
                <CloseButton onClick={dismiss} />
            </Header>
            <Message
                type="info"
                message={formatMessage({
                    id: 'documents_signing_message_email_link_plural',
                    defaultMessage: 'You have received a link via email where you can sign these documents.'
                })} />
            <Documents />
        </>
    )
}

export default SigningPanelContent
